import { useQuery } from "react-query";
import { sampleTemplateGetConfig } from "../api/sampletemplate";

export const useGetSampleTemplateConfigById = (id) => {
  return useQuery(
    ["GetSampleTemplateConfigById", id],
    () => sampleTemplateGetConfig(id),
    { enabled: !!id },
  );
};

export default {
  useGetSampleTemplateConfigById,
};
